/* eslint-disable @typescript-eslint/naming-convention */
export class HttpResponse {
    public static readonly OK: number = 200;
    public static readonly NO_CONTENT: number = 204;
    public static readonly MULTI_STATUS: number = 207;
    public static readonly BAD_REQUEST: number = 400;
    public static readonly UNAUTHORIZED: number = 401;
    public static readonly FORBIDDEN: number = 403;
    public static readonly NOT_FOUND: number = 404;
    public static readonly METHOD_NOT_ALLOWED: number = 405;
    public static readonly CONFLICT: number = 409;
    public static readonly UNPROCESSABLE_ENTITY: number = 422;
    public static readonly INTERNAL_SERVER_ERROR: number = 500;
}
